const lang = {
  en: {
    search: "Search",
    gptSearchPlaceholder: "What do you like to watch today?",
  },
  telugu: {
    search: "శోధించండి",
    gptSearchPlaceholder: "ఈరోజు మీరు ఏమి చూడటానికి ఇష్టపడతారు?",
  },
  hindi: {
    search: "खोज",
    gptSearchPlaceholder: "आज आप क्या देखना पसंद करेंगे?",
  },
  spanish: {
    search: "Buscar",
    gptSearchPlaceholder: "¿Qué te gusta ver hoy?",
  },
};

export default lang;
